import {
  createApiFactory,
  createPlugin,
  createRoutableExtension,
  discoveryApiRef,
  fetchApiRef,
  identityApiRef,
} from '@backstage/core-plugin-api';
import { FfgClient } from './api/client';
import {
  rootRouteRef,
  unusedRoutesRouteRef,
  sensitiveRoutesRouteRef,
} from './routes';
import { ffgApiRef } from './api/api';

export const ffgPlugin = createPlugin({
  id: 'ffg',
  apis: [
    createApiFactory({
      api: ffgApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
        identityApi: identityApiRef,
      },
      factory({ discoveryApi, fetchApi, identityApi }) {
        return new FfgClient({
          discoveryApi,
          fetchApi,
          identityApi,
        });
      },
    }),
  ],
  routes: {
    root: rootRouteRef,
    unusedRoutes: unusedRoutesRouteRef,
    sensitiveRoutes: sensitiveRoutesRouteRef,
  },
});

export const FfgPage = ffgPlugin.provide(
  createRoutableExtension({
    name: 'FfgPage',
    component: () => import('./components/Router').then(m => m.Router),
    mountPoint: rootRouteRef,
  }),
);
